define.alias("shared/components/shared/suggestion-text-area", "preview-grid/components/shared/suggestion-text-area");